import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// The SDK retries network errors, CORS failures and 5xx silently for up to 10
// minutes (2 for other calls) before it rejects. Cap that so a failing upload
// reports its error code. It does NOT time out a request already in flight —
// the SDK never aborts one, and a slow upload on a poor connection still
// completes; Screen Themes offers Cancel for that case.
storage.maxUploadRetryTime = 60000;
storage.maxOperationRetryTime = 30000;
export const functions = getFunctions(app, 'us-central1');

export default app;